import { render, staticRenderFns } from "./newbranch.vue?vue&type=template&id=b9c11246&scoped=true"
import script from "./newbranch.vue?vue&type=script&lang=js"
export * from "./newbranch.vue?vue&type=script&lang=js"
import style0 from "./newbranch.vue?vue&type=style&index=0&id=b9c11246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c11246",
  null
  
)

export default component.exports